import PropTypes from "prop-types";
import React, { useEffect } from "react";

import { Link } from "@swa-ui/core";

import { useHrefWithSearchParams } from "../useHrefWithSearchParams";

/**
 * LinkWithSearchParams creates a link on the page that encrypts its href and
 * automatically updates the link when the encryption context changes. It
 * optionally accepts a list of validations and will call the onValidationError
 * callback if any of the validations fail.
 */
export const LinkWithSearchParams = (props) => {
  const {
    basePath,
    children,
    componentName,
    feature,
    onValidationError,
    validations,
    searchParams,
    ...otherProps
  } = props;

  const { errors, href } = useHrefWithSearchParams(
    basePath,
    searchParams,
    validations,
    componentName,
    feature
  );

  useEffect(() => {
    if (errors.length > 0 && onValidationError) {
      onValidationError(errors);
    }
  }, [errors]);

  return <Link {...{ ...otherProps, href }}>{children}</Link>;
};

LinkWithSearchParams.propTypes = {
  /** The base path for the HREF to generate with the encrypted params */
  basePath: PropTypes.string.isRequired,

  /** Content that will be rendered within the link. */
  children: PropTypes.node,

  /** The name of the component to be logged if encryption fails */
  componentName: PropTypes.string,

  /** The feature value to determine which encryption method to use */
  feature: PropTypes.string,

  /** A callback function that is triggered when there are validation errors on the params */
  onValidationError: PropTypes.func,

  /** An object containing the search params to be included in the final HREF */
  searchParams: PropTypes.object,

  /** A set of validations to be performed on the search params provided */
  validations: PropTypes.shape({
    validateSync: PropTypes.func.isRequired,
  }),
};
